<script setup lang="ts">
import { defineProps } from 'vue'

defineProps({
  withActions: {
    type: Boolean,
    default: false
  },
  xs: {
    type: String,
    default: "12"
  },
  sm: {
    type: String,
    default: "8"
  },
  md: {
    type: String,
    default: "6"
  },
  lg: {
    type: String,
    default: "4"
  },
  xl: {
    type: String,
    default: "3"
  }
})
</script>

<template>
  <v-col v-bind="{ xs, sm, md, lg, xl }">
    <v-card>
      <v-card-title class="font-weight-bold">
        <slot name="title"/>
      </v-card-title>
      <v-card-item>
        <slot name="item"/>
        <slot name="component"/>
      </v-card-item>
      <v-card-actions v-if="withActions">
        <div class="d-flex flex-row justify-end ga-2 w-100">
          <slot name="actions"/>
        </div>
      </v-card-actions>
    </v-card>
  </v-col>
</template>
